<template>
	<card
		class="no-border-card"
		header-classes="d-flex justify-content-between align-items-center border-0 bg-dark"
		body-classes="p-0 pb-1"
		footer-classes="pb-2 border-0"
	>
		<template slot="header">
			<h3 class="mb-0 text-white">
				รายการรับโบนัส
				<small>(50 รายการล่าสุด)</small>
			</h3>

			<el-select class="select-primary pagination-select" placeholder="Per page" v-model="pagination.perPage">
				<el-option
					class="select-primary"
					v-for="item in pagination.perPageOptions"
					:key="item"
					:label="item"
					:value="item"
				/>
			</el-select>
		</template>

		<div>
			<el-table row-key="id" header-row-class-name="thead-light" :data="queriedData">
				<el-table-column label="วัน/เวลา" min-width="150px">
					<div slot-scope="{ row }">
						{{ row.createdAt | moment('DD/MM/YYYY HH:mm:ss') }}
					</div>
				</el-table-column>
				<el-table-column label="จำนวนเงิน" min-width="150px">
					<div slot-scope="{ row }">
						<h4 class="mb-0">{{ row.amount | format(2) }}</h4>
						<small class="d-block">{{ row.promotion.name }}</small>
					</div>
				</el-table-column>
				<el-table-column label="ยอดเทิร์น" min-width="100px">
					<div slot-scope="{ row }">
						{{ row.totalTurn | format(2) }}
					</div>
				</el-table-column>
			</el-table>
		</div>
		<div class="col-12 d-flex justify-content-between" slot="footer">
			<p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>

			<base-pagination
				class="pagination-no-border"
				:per-page="pagination.perPage"
				:total="total"
				v-model="pagination.currentPage"
			/>
		</div>
	</card>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '../../components'

import tablePagination from '../../mixins/tablePagination'

export default {
	props: ['data'],
	mixins: [tablePagination([], 5)],
	components: {
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	created() {
		this.updateTableData(this.data)
	},
	watch: {
		data(v) {
			this.updateTableData(v)
		},
	},
}
</script>
